export default "__VITE_ASSET__2b3ca1d6__"